import gql from "graphql-tag";

const REVISE_PRICES = gql`
  mutation revisePrices($data: [RevisedPricesInput], $projectId: String!) {
    revisePrices(data: $data, projectId: $projectId)
  }
`;

export default REVISE_PRICES;
